export interface CsvError {
  code: string;
  message: string;
  description?: string;
}

export const csvErrorCodes: Record<string, CsvError> = {
  "A2-101": {
    code: "A2-101",
    message: "storeするCSVのエンコード形式が非対応",
    description: "CSVファイルのエンコード形式がサポートされていません。UTF-8形式で保存し直してください。"
  },
  "A2-102": {
    code: "A2-102", 
    message: "store時にDBにアクセスできなかった",
    description: "データベースへの接続に失敗しました。しばらく時間をおいて再度お試しください。"
  },
  "A2-103": {
    code: "A2-103",
    message: "store時に、clientがDBに登録されていない", 
    description: "クライアントがデータベースに登録されていません。管理者にお問い合わせください。"
  },
  "A2-104": {
    code: "A2-104",
    message: "store時に、該当するファイルが見つからない",
    description: "指定されたファイルが見つかりません。ファイルが削除されていないか確認してください。"
  },
  "A2-100": {
    code: "A2-100",
    message: "store時の予期しないエラー",
    description: "予期しないエラーが発生しました。管理者にお問い合わせください。"
  },
  "U4-101": {
    code: "U4-101",
    message: "CSVストレージ処理エラー",
    description: "CSVファイルの処理中にエラーが発生しました。"
  },
  "U4-100": {
    code: "U4-100", 
    message: "store時の予期しないエラー",
    description: "予期しないエラーが発生しました。管理者にお問い合わせください。"
  },
  "R2-101": {
    code: "R2-101",
    message: "CSV読み取りエラー",
    description: "CSVファイルの読み取り中にエラーが発生しました。"
  },
  "R2-102": {
    code: "R2-102",
    message: "CSV読み取りエラー",
    description: "CSVファイルの読み取り中にエラーが発生しました。"
  },
  "U7-100": {
    code: "U7-100",
    message: "CSVデータフォーマットエラー",
    description: ""
  }
};

export function getCsvErrorByCode(code: string): CsvError | null {
  return csvErrorCodes[code] || null;
}